import { render, staticRenderFns } from "./examuser.vue?vue&type=template&id=5343173e&scoped=true&"
import script from "./examuser.vue?vue&type=script&lang=js&"
export * from "./examuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343173e",
  null
  
)

export default component.exports